import { render, staticRenderFns } from "./MainBookPrint.vue?vue&type=template&id=472d5972&scoped=true"
import script from "./MainBookPrint.vue?vue&type=script&lang=js"
export * from "./MainBookPrint.vue?vue&type=script&lang=js"
import style0 from "./MainBookPrint.vue?vue&type=style&index=0&id=472d5972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d5972",
  null
  
)

export default component.exports